// extracted by mini-css-extract-plugin
module.exports = {"st0":"info-icon_st0__3EAGS","st1":"info-icon_st1__3_3VG","st2":"info-icon_st2__fLtR-","st3":"info-icon_st3__2Qock","st4":"info-icon_st4__ri-fA"};